import { Label } from '@/shared/components/ui/label';
import { ManualReferralEntitySelect } from './ManualReferralEntitySelect';
import { modeButtonClass, type CareSeekerMode } from './manualReferralForm';
import type { ManualReferralEntitySearchItem } from '../../types/manual-referral.type';

type ManualReferralCareSeekerSelectProps = {
  mode: CareSeekerMode;
  selectedCareSeeker: ManualReferralEntitySearchItem | null;
  onModeChange: (mode: CareSeekerMode) => void;
  onSelectExisting: (careSeeker: ManualReferralEntitySearchItem) => void;
};

export const ManualReferralCareSeekerSelect = ({
  mode,
  selectedCareSeeker,
  onModeChange,
  onSelectExisting,
}: ManualReferralCareSeekerSelectProps) => (
  <div className="space-y-2">
    <Label>Care seeker</Label>
    <div className="flex flex-wrap gap-2" role="group" aria-label="Care seeker type">
      <button
        type="button"
        aria-pressed={mode === 'search'}
        className={modeButtonClass(mode === 'search')}
        onClick={() => onModeChange('search')}
      >
        Search existing
      </button>
      <button
        type="button"
        aria-pressed={mode === 'new'}
        className={modeButtonClass(mode === 'new')}
        onClick={() => onModeChange('new')}
      >
        Add new care seeker
      </button>
      <button
        type="button"
        aria-pressed={mode === 'none'}
        className={modeButtonClass(mode === 'none')}
        onClick={() => onModeChange('none')}
      >
        No care seeker
      </button>
    </div>

    {mode === 'search' && (
      <ManualReferralEntitySelect
        label=""
        searchLabel="Care seeker search"
        entityType="CARE_SEEKER"
        selected={selectedCareSeeker}
        onSelect={onSelectExisting}
      />
    )}
    {mode === 'none' && (
      <p className="rounded-md border border-gray-200 bg-gray-50 p-3 text-sm text-gray-700">
        The referral is recorded without a linked care seeker. No care seeker emails or
        feedback requests will be sent.
      </p>
    )}
  </div>
);
